import { ConnectedRouter } from 'connected-react-router';
import {
  configureStore,
  getHistory,
} from 'src/modules/store';
import React from 'react';
import { Provider, useSelector } from 'react-redux';
import RoutesComponent from 'src/view/shared/routes/RoutesComponent';
import layoutSelectors from 'src/modules/layout/layoutSelectors';
import { useAnalytics } from './useAnalytics';

const store = configureStore();

const App = (props) => {
  const history = getHistory();
  useAnalytics(history);

  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <AppInnerComponent />
      </ConnectedRouter>
    </Provider>
  );
};

const AppInnerComponent = (props) => {
  const isDarkMode = useSelector(
    layoutSelectors.selectDarkMode,
  );
  return (
    <div className={`${isDarkMode ? 'dark' : ''}`}>
      <RoutesComponent />
    </div>
  );
};

export default App;
